let prefix = '/api/status';

function getStatus() {
    return window.axios.get(prefix);
}

export default {
    getStatus
    
}